import {
  UPDATE_DYNAMIC_TAB_TITLE
} from './actionTypes';
import { createAction } from '../utils/createAction';

export const updateDynamicTabTitle = createAction(UPDATE_DYNAMIC_TAB_TITLE, 'dynamicTabTitle');
